<vi-loader
  *ngIf="dashboardStoreStatus === dashboardStoreStatusTypes.Initializing"
  [isLoading]="true"
  [viOrangeTheme]="true"
  size="large"
  titleKey="+DASHBOARD.DASHBOARD_TILES.LOADING"
  message="+DASHBOARD.DASHBOARD_TILES.LOADING_DATA"
>
</vi-loader>

<div
  class="banner-container"
  *ngIf="
    dashboardStoreStatus === dashboardStoreStatusTypes.EmptyTile ||
    dashboardStoreStatus === dashboardStoreStatusTypes.EmptyTab
  "
>
  <app-banner
    [type]="
      tileType === dashboardTileType.DevicesWithLowWifi ? bannerType.success : bannerType.info
    "
    isFullWidth="true"
  >
    <p class="banner-text">
      {{
        dashboardStoreStatus === dashboardStoreStatusTypes.EmptyTile
          ? emptyTileDataText
          : emptyTabDataText
      }}
    </p>
  </app-banner>
</div>

<div
  class="banner-container"
  *ngIf="
    dashboardStoreStatus === dashboardStoreStatusTypes.ErrorTile ||
    dashboardStoreStatus === dashboardStoreStatusTypes.ErrorTab
  "
>
  <app-banner [type]="bannerType.error" isFullWidth="true">
    <div class="banner-container__content">
      <p class="banner-text">
        {{ errorBannerText }}
      </p>
      <button
        mat-stroked-button
        color="secondary"
        gtm="onReload"
        gtmAction="Reload"
        gtmCategory="dashboard"
        (click)="onReloadClick()"
      >
        {{ errorBannerBannerButtonLabel }}
      </button>
    </div>
  </app-banner>
</div>
